module.exports = __webpack_public_path__ + "img/examine-disabled.10fb5472.png";